module.exports = __webpack_public_path__ + "img/premio1.fa65138a.webp";